module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    attrs: {
      "header": _vm.caption
    }
  }, [_c('b-link', {
    attrs: {
      "to": {
        name: 'welcome-category-create'
      }
    }
  }, [_c('b-button', {
    style: ({
      marginBottom: '18px'
    }),
    attrs: {
      "variant": "outline-primary"
    }
  }, [_vm._v("\n        创建分类\n      ")])], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "responsive": "sm",
      "busy": _vm.items === null,
      "items": _vm.items,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "emptyText": _vm.tableEmptyText
    },
    scopedSlots: _vm._u([{
      key: "cell(op)",
      fn: function(data) {
        return [_c('b-link', {
          attrs: {
            "to": {
              name: 'welcome-category-update',
              params: {
                categoryCode: data.item.code
              }
            }
          }
        }, [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-warning"
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" 编辑\n          ")])], 1), _vm._v(" "), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteTip(data.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o"
        }), _vm._v(" 删除\n        ")])]
      }
    }, {
      key: "table-busy",
      fn: function() {
        return [_c('div', {
          staticClass: "text-center text-danger my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        }), _vm._v(" "), _c('strong', [_vm._v("加载中...")])], 1)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "prev-text": "<<",
      "next-text": ">>",
      "hide-goto-end-buttons": "",
      "first-number": "",
      "last-number": ""
    },
    on: {
      "change": _vm.changePage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), _c('TipModal', {
    ref: "tip",
    attrs: {
      "tipData": _vm.tipData
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-dark"
          },
          on: {
            "click": function($event) {
              return _vm.cancelDelete()
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCategory()
            }
          }
        }, [_vm._v("删除")])]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6f2e3a5f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/welcomeSetting/Category.vue
// module id = Ud43
// module chunks = 4